module.exports = __webpack_public_path__ + "img/infrastructure.cd30263a.png";